module.exports = __webpack_public_path__ + "media/images/shark/SharkSocial-43a690b8087c34f2bd703342ea958ee2.jpg";